export default "__VITE_ASSET__5b21ba59__"